/**
 * Legacy module shell — kept so AngularJS modules that declare
 * 'acme.common.service.rulesEngine' as a dependency keep bootstrapping.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/rules-engine/rules-engine.service.ts
 *
 * Registered with AngularJS via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any $inject = ['RulesEngineService'] resolves to the Angular 18 class.
 *
 * Do NOT register `.service('RulesEngineService', ...)` here — it would shadow
 * the downgraded Angular 18 service.
 */
angular.module('acme.common.service.rulesEngine', ['acme.common.service.helpers']);
